import URI from 'jsuri';
import Q from 'q';

import { getAnswerApi } from 'bundles/discussions/api/forumApiChoiceUtil';
import { answerSorts } from 'bundles/discussions/constants';
import type { AnswerSort, ForumTypeName } from 'bundles/discussions/constants';
import {
  answerFields,
  answerIncludes,
  getAnswerApiName,
  getParamsForForumType,
  profilesFields,
} from 'bundles/discussions/utils/forumsApiUtils';

const getAllAnswerFields = (apiName: string) => [
  answerFields.join(','),
  `onDemandSocialProfiles.v1(${profilesFields.join(',')})`,
  `${apiName}(${answerFields.join(',')})`,
];

export const loadReplies = function ({
  sort,
  pageNum,
  filterQueryString,
  limit = 15,
  forumType,
  forumId,
  userId,
  creatorId,
  includeDeleted,
}: {
  sort: AnswerSort;
  pageNum: number;
  filterQueryString: string;
  limit: number;
  forumType: ForumTypeName;
  forumId: string;
  userId: string | number;
  creatorId: string | number;
  includeDeleted: boolean;
}) {
  const uri = new URI()
    .addQueryParam('userId', userId)
    .addQueryParam('creatorId', creatorId)
    .addQueryParam('shouldAggregate', 'true')
    .addQueryParam('includeDeleted', includeDeleted ? 'true' : 'false')
    .addQueryParam('sort', sort || answerSorts.newestSort)
    .addQueryParam('fields', getAllAnswerFields(getAnswerApiName(forumType)).join(','))
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
    .addQueryParam('includes', answerIncludes)
    .addQueryParam('limit', limit);

  const additionalParams = getParamsForForumType(forumType, forumId);
  Object.keys(additionalParams).forEach((key) => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    uri.addQueryParam(key, additionalParams[key]);
  });

  if (filterQueryString) {
    uri.addQueryParam('sessionFilter', filterQueryString);
  }

  if (pageNum - 1 > 0) {
    uri.addQueryParam('start', (pageNum - 1) * limit);
  }
  return Q(getAnswerApi(forumType).get(uri.toString()));
};
